import { createSelector } from 'reselect'

export default (reducerName) => {
  const getData = state => state[reducerName].data
  const getTimestamp = state => state[reducerName].ts

  return createSelector(
    getData,
    getTimestamp,
    (data, ts) => {
      return {
        ts,
        data
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/store/utils/syncSelector.js